import { DatePicker, RadioButton, TextField } from "@aeco-cloud/react-easy-form";
import { IconButton, useTheme } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import settings from "@styles/settings";
import { useContext } from "react";
import type { CSSProperties } from "react";
import { UseFormMethods } from "react-hook-form";
import { TextContext } from "../../../../pages/bepaal-statuut";
import { Label, Question, Section } from "../../../form-layout";
import { isValid, isBefore, isAfter, Interval } from "date-fns";

export default function Contract(props: {
  form: UseFormMethods;
  contractNumber: number;
  contractArray: any[];
  deleteContract: any;
  quarterInterval: Interval;
}) {
  const text = useContext(TextContext);
  const theme = useTheme();

  return (
    <Section>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {" "}
        <div style={theme.typography.h5 as unknown as CSSProperties}>
          {text.performedHours_contractTitle}
        </div>
        <IconButton
          style={{ display: props.contractNumber === 1 ? "none" : "inline" }}
          aria-label="delete"
          color="secondary"
          onClick={() => {
            props.deleteContract(props.contractNumber);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fit, minmax(240px,1fr))`,
          // gridAutoRows: `100px` with this property we might be able to fix the error-allignment of adjacent elements issue
        }}
      >
        <Question>
          <Label
            label={text.performedHours_contract_startDate_label}
            tooltip={text.performedHours_contract_startDate_tooltip}
          />
          <DatePicker
            name={`contract${props.contractNumber}_startDate`}
            rules={{
              required: text.general_requiredQuestion,
              validate: {
                couldNotBeParsed: (value: any) => isValid(value) || text.general_dateNotValid,
                shouldBeBeforeQuarter: (value: Date) => {
                  return (
                    isBefore(value, props.quarterInterval.end) ||
                    text.contract_dateCantBeAfterChosenQuarter
                  );
                },
              },
            }}
            muiKeyBoardDatePickerProps={{ fullWidth: true, inputVariant: "outlined" }}
          />
        </Question>
        <Question>
          <Label
            label={text.performedHours_contract_endDate_label}
            tooltip={text.performedHours_contract_endDate_tooltip}
          />
          <DatePicker
            name={`contract${props.contractNumber}_endDate`}
            muiKeyBoardDatePickerProps={{ fullWidth: true, inputVariant: "outlined" }}
            rules={{
              validate: {
                couldNotBeParsed: (value: any) => {
                  if (!value) {
                    return true;
                  } else {
                    return isValid(value) || text.general_dateNotValid;
                  }
                },
                shouldBeAfterStartDate: (value: Date) => {
                  if (!value) {
                    return true;
                  } else {
                    return (
                      isAfter(
                        value,
                        props.form.watch(`contract${props.contractNumber}_startDate`)
                      ) || text.contract_endDateShouldBeAfterStartDate
                    );
                  }
                },
              },
            }}
          />
        </Question>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fit, minmax(240px,1fr))`,
        }}
      >
        <Question>
          <Label
            label={text.performedHours_contract_employmentRateNumerator_label}
            tooltip={text.performedHours_contract_employmentRateNumerator_tooltip}
          />
          <TextField
            name={`contract${props.contractNumber}_employmentRateNumerator`}
            rules={{
              required: text.general_requiredQuestion,
            }}
            muiTextFieldProps={{ type: "number", fullWidth: true, variant: "outlined" }}
          />
        </Question>
        <Question>
          <Label
            label={text.performedHours_contract_employmentRateDenominator_label}
            tooltip={text.performedHours_contract_employmentRateDenominator_tooltip}
          />
          <TextField
            name={`contract${props.contractNumber}_employmentRateDenominator`}
            rules={{
              required: text.general_requiredQuestion,
            }}
            muiTextFieldProps={{ type: "number", fullWidth: true, variant: "outlined" }}
          />
        </Question>
      </div>
      <Question>
        <Label
          label={text.performedHours_contract_allDays_label}
          tooltip={text.performedHours_contract_allDays_tooltip}
        />
        <RadioButton
          name={`contract${props.contractNumber}_allDays`}
          minButtonWidth="240px"
          {...settings.selectButtonsProps}
          options={[
            { value: "true", label: text.general_yes },
            { value: "false", label: text.general_no },
            { value: "maybe", label: text.general_iDontKnow },
          ]}
          rules={{
            required: text.general_requiredQuestion,
          }}
        />
      </Question>
      <Question
        showIf={["false", "maybe"].includes(
          props.form.watch(`contract${props.contractNumber}_allDays`)
        )}
      >
        <Label
          label={text.performedHours_contract_performedHours_label}
          tooltip={text.performedHours_contract_performedHours_tooltip}
        />
        <TextField
          name={`contract${props.contractNumber}_performedHours`}
          rules={{
            required: text.general_requiredQuestion,
          }}
          muiTextFieldProps={{ type: "number", fullWidth: true, variant: "outlined" }}
        />
      </Question>
    </Section>
  );
}
